<template>
  <!-- PAGE : EXPERIENCE -->
  <section id="experience" class="page">
    <div class="content">
      <!-- CONTENT -->

      <!-- row -->
      <div class="row">
        <!-- col 6/12 -->
        <div class="col-md-6">
          <!-- timeline -->
          <div class="timeline" v-for="timeline in timelines" :key="timeline.title">
            <h2>
              <i :class="timeline.icon"></i>
              {{ timeline.title }}
            </h2>
            <div
                class="event"
                v-for="(items, index) in timeline.details"
                :class="[items.type, items.classname]"
                :key="index.toString()"
            >
              <span class="date">{{ items.year }}</span>
              <h4>{{ items.position }}</h4>
              <h5>{{ items.subtitle }}</h5>
              <p>{{ items.description }}</p>
            </div>
          </div>
        </div>
        <!-- col 6/12 -->

        <!-- col 6/12 -->
        <div class="col-md-6">
          <section-title :title="skills.title" :icon="skills.icon" />
          <power-bars :skills="skills" />

          <!-- testo-group -->
          <section-title :title="testimonials.title" :icon="testimonials.icon" />

          <!-- testo-group -->
          <div class="testo-group">
            <!-- Testimonial -->
            <div class="testo" v-for="testo in testimonials.details" :key="testo.name">
              <img v-if="testo.image" :src="testo.image" alt="someone" />
              <h4>
                {{ testo.name }}
                <span>{{ testo.post }}</span>
              </h4>
              <p v-html="testo.testimonial" />
            </div>
            <!-- Testimonial -->
          </div>

          <!-- Resume -->
<!--          <template v-if="!!resume">-->
<!--            <section-title :title="resume.title" :icon="resume.icon" />-->

<!--            <p v-html="resume.description" v-if="resume.description" />-->

<!--            &lt;!&ndash; DOWNLOAD BUTTON &ndash;&gt;-->
<!--            <div class="download-button">-->
<!--              <a :href="resume.link" class="button" v-html="resume.button" />-->
<!--            </div>-->
<!--          </template>-->

          <!-- Link to Profile -->
          <template v-if="!!profile">
            <section-title :title="profile.title" :icon="profile.icon" />

            <p v-html="profile.description" v-if="profile.description" />

            <!-- DOWNLOAD BUTTON -->
            <div class="download-button">
              <link-button
                  :href="profile.link"
                  :btnClasses="profile.button.btnClasses"
                  :title="profile.button.title"
                  :icon="profile.button.icon"
              />

            </div>
          </template>
        </div>
        <!-- col 6/12 -->
      </div>
      <!-- row -->
    </div>
    <!-- CONTENT -->
  </section>
  <!-- PAGE : EXPERIENCE -->
</template>

<script>
    import RESUMEDETAILS from "@/json/resumeDetails";
    import LinkButton from "../components/LinkButton";
    import PowerBars from "../components/PowerBars";

    export default {
        name: "Experience",
        components: {PowerBars, LinkButton},
        data() {
            return RESUMEDETAILS;
        }
    };
</script>
